export default {
  computed: {
    locale() {
      return this.localeModel || this.$root.$i18n?.locale || "en-CA";
    },

    localeLanguageOptions() {
      return {
        "en-CA": {
          text: this.$t("global.words.english"),
          shortVersion: "EN",
          id: "en-CA"
        },
        "fr-CA": {
          text: this.$t("global.words.french"),
          shortVersion: "FR",
          id: "fr-CA"
        }
      };
    },

    $_withConfirmation() {
      return this.withConfirmation ?? true;
    },

    currentLocale() {
      const currentLocale = this.locale;
      return this.localeLanguageOptions[currentLocale];
    }
  },

  methods: {
    handleLanguageSelect(lang) {
      if (this.$_withConfirmation) {
        const confirm = window.confirm(
          this.$t("global.messages.langSelectorChange")
        );
        if (!confirm) return;
        else this.handleLocalChange?.(lang);
      }

      if (this.localeModel !== null) {
        return this.$emit("update:localeModel", lang);
      }

      this.$root.$i18n.locale = lang;
    }
  }
};
